import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import styles from "./button.module.css"

type ButtonVariant = "primary" | "destructive" | "default" | "secondary" | "ghost" | "link"
type ButtonSize = "default" | "md" | "sm" | "lg" | "icon"

interface ButtonProps extends React.ComponentProps<"button"> {
  variant?: ButtonVariant
  size?: ButtonSize
  asChild?: boolean
}

function Button({
  className,
  variant = "default",
  size = "default",
  asChild = false,
  ...props
}: ButtonProps) {
  const Comp = asChild ? Slot : "button"

  // Map variant names to CSS module classes
  const variantClassMap: Record<ButtonVariant, string> = {
    primary: styles.primary,
    default: styles.default,
    destructive: styles.destructive,
    secondary: styles.secondary,
    ghost: styles.ghost,
    link: styles.link,
  }

  // Build className string from CSS modules
  const buttonClasses = [
    styles.button,
    variantClassMap[variant],
    styles[`size-${size === "md" ? "default" : size}`],
    className
  ].filter(Boolean).join(' ')

  return (
    <Comp
      data-slot="button"
      className={buttonClasses}
      {...props}
    />
  )
}

export { Button }
export type { ButtonProps, ButtonVariant, ButtonSize }
